import { z } from 'zod'
import { agentV2Request } from '@/agent-v2/conversations/fetch/agent-v2-request'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { MatterReadSchema, type MatterRead } from '@/matter/store/schemas'

const WorkspaceResponseSchema = z.object({ workspace: MatterReadSchema.nullable() })

export async function getOutlookWorkspace(): Promise<MatterRead | null> {
  const result = await agentV2Request({
    method: 'GET',
    url: `${kPaxtonAppApiRESTBaseUrl()}/api/v2/outlook/workspace`,
    sentryEndpoint: 'outlook.workspace.get',
    parseResponse: (data) => WorkspaceResponseSchema.parse(data),
  })
  return result.workspace
}

export async function createOutlookWorkspace(): Promise<MatterRead> {
  const result = await agentV2Request({
    method: 'POST',
    url: `${kPaxtonAppApiRESTBaseUrl()}/api/v2/outlook/workspace`,
    sentryEndpoint: 'outlook.workspace.create',
    parseResponse: (data) => z.object({ workspace: MatterReadSchema }).parse(data),
  })
  return result.workspace
}
